import { useState } from 'react';
import { Box, Typography } from '@mui/material';

import { ChatComponentType, Message } from './type/chat.types';
import ChatMessages from './components/chat-message/chat-messages';
import ChatInput from './components/chat-input/chat-input';
import SatisfactionComponent from './components/satisfaction/satisfaction';
import ChatLoading from './components/chat-loading/chat-loading';
import ChatFailed from './components/chat-failed/chat-failed';

const ChatComponent = (props: ChatComponentType) => {
    const [replyTo, setReplyTo] = useState<Message | undefined>();
    const hasMessages = Boolean(props?.chatInfo?.message?.items?.length);

    if (props?.loadingMessages) {
        return <ChatLoading />;
    }

    if (!props?.chatInfo) {
        return <ChatFailed onRefetchInfo={props?.onRefetchInfo} />;
    }

    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}>
            {hasMessages ? (
                <ChatMessages
                    userInfo={props?.userInfo}
                    messages={props?.chatInfo?.message.items}
                    totalPages={props?.totalPages}
                    isSending={props?.isSendingMessage}
                    isRestoreDelete={props?.isRestoreDeleteMessage}
                    isMessageError={props?.isMessageError}
                    avatarPrimaryRoute={props?.avatarPrimaryRoute}
                    avatarSecondaryRoute={props?.avatarSecondaryRoute}
                    onPaginate={props?.onPaginate}
                    onDeleteOrRestore={props?.onDeleteOrRestore}
                    onEdit={props?.onEdit}
                    onReply={setReplyTo}
                    gatewayOwnerId={
                        props?.chatInfo?.gateway_id
                            ? props?.chatInfo?.user_info?.id
                            : undefined
                    }
                    gatewayName={
                        props?.chatInfo?.gateway?.title ||
                        props?.chatInfo?.gateway?.website ||
                        undefined
                    }
                />
            ) : (
                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        px: 2,
                        py: 3,
                    }}>
                    <Typography
                        variant="body2"
                        sx={{ color: 'text.secondary', textAlign: 'center' }}>
                        پیامی برای این تیکت ثبت نشده است.
                    </Typography>
                </Box>
            )}

            {props?.chatInfo?.status === 'closed' && props?.onSatisfaction ? (
                <SatisfactionComponent
                    chatInfo={props?.chatInfo}
                    onSatisfaction={props?.onSatisfaction}
                />
            ) : (
                <ChatInput
                    isSending={props?.isSendingMessage}
                    isMessageError={props?.isMessageError}
                    setIsMessageError={props?.setIsMessageError}
                    editingMessage={props?.editingMessage}
                    sentMessage={props?.sentMessage}
                    replyTo={replyTo}
                    onCancelReply={() => setReplyTo(undefined)}
                    fileUploadUrl={props?.fileUploadUrl}
                    inputProps={props?.inputProps}
                    maxLength={props?.maxLength}
                    fileSizeLimit={props?.fileSizeLimit}
                    onSend={props?.onSend}
                    onResend={props?.onResend}
                    onCancel={props?.onCancel}
                    onEdit={props?.onEdit}
                    onCancelEdit={props?.onCancelEdit}
                    onErrorFile={props?.onErrorFile}
                />
            )}
        </Box>
    );
};

export default ChatComponent;
